// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3N_MB","noInteraction":"EventWrapper_noInteraction__xineN"};